import { createTableDataFilter } from "../CategoryLeadersTable/CategoryLeadersTableTop/CategoryLeadersTableTopUtils";
import { useCallback, useMemo, useState } from "react";
import type { PaidOrganicFilterEnum } from "./PaidOrganicFilter.types";

const PAID_ORGANIC_FILTER_KEY = "OP";

export const usePaidOrganicFilter = () => {
    const [selectedPaidOrganicId, setSelectedPaidOrganicId] = useState<PaidOrganicFilterEnum>(null);

    const paidOrganicFilter = useMemo(() => {
        return createTableDataFilter(PAID_ORGANIC_FILTER_KEY, selectedPaidOrganicId);
    }, [selectedPaidOrganicId]);

    const onSelectPaidOrganicId = useCallback(
        (selectedId) => {
            setSelectedPaidOrganicId(selectedId);
        },
        [setSelectedPaidOrganicId],
    );

    return {
        selectedPaidOrganicId,
        paidOrganicFilter,
        onSelectPaidOrganicId,
    };
};
